import React from "react";
const MainFooter = () => (
  <div
    style={{
      marginTop: "100px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "black",
      height: "60px",
      width: "100%",
    }}
  >
    <p style={{ color: "white", margin: "0px" }}>
      © Copyrights madinetmasr.com - All rights reserved | Powered by TAC
      Universe
    </p>
  </div>
);

export default MainFooter;
